import { jsx } from "react/jsx-runtime";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import { validateTidalLicense } from "../../base/index.js";
function FolderOpen(props) {
  return /* @__PURE__ */ jsx(
    FolderOpenIcon,
    {
      "data-testid": "FolderOpen",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FolderOpen",
      "data-tidal-icon-meta": "folders,notes,lists"
    }
  );
}
FolderOpen.tidalIconMeta = {
  categories: "folders,notes,lists",
  name: "FolderOpen"
};
validateTidalLicense();
export {
  FolderOpen
};
//# sourceMappingURL=FolderOpen.js.map
